<template>
    <div class="rmp">
        <h6 class="mb-1">{{ mission.name || 'Mission' }}</h6>
        <div class="text-muted small mb-2">#{{ mission.id }}</div>
        <div class="text-muted small mb-3">
            <div>Status : <strong>{{ mission.statusLabel || mission.status }}</strong></div>
            <div v-if="mission.transporteurName">Transporteur : <strong>{{ mission.transporteurName }}</strong></div>
            <div v-if="corridoringName">Corridoring : {{ corridoringName }}</div>
        </div>

        <div v-if="corridoringName" class="form-check form-switch border-top pt-2 mb-3">
            <input
                id="showCorridoringSwitch"
                class="form-check-input"
                type="checkbox"
                :checked="showCorridoring"
                @change="$emit('update:showCorridoring', $event.target.checked)"
            />
            <label class="form-check-label small" for="showCorridoringSwitch">
                Afficher corridoring
            </label>
        </div>

        <div class="small-text row g-0 text-center border-top pt-2 mb-2">
            <div class="col-12 mb-2">
                <small class="fw-bold">Départ </small>
                <small class="text-muted">{{ mission.displayStartDate || mission.startDate }}</small>
                <div v-if="mission.startAddress"><small>{{ mission.startAddress }}</small></div>
            </div>
            <div class="col-12">
                <hr class="my-2" />
            </div>
            <div class="col-12 mb-2">
                <small class="fw-bold">Arrivée </small>
                <small class="text-muted">{{ mission.displayEndDate || mission.endDate }}</small>
                <div v-if="mission.endAddress"><small>{{ mission.endAddress }}</small></div>
            </div>
        </div>

        <div class="row g-0 align-items-center mb-3">
            <div class="col text-start"><small class="fw-bold">Durée :</small></div>
            <div class="col text-start px-1">
                <small>{{ mission.duration || '—' }}</small>
            </div>
        </div>
        <div class="row g-0 align-items-center mb-3">
            <div class="col text-start"><small class="fw-bold">Distance :</small></div>
            <div class="col text-start px-1">
                <small>{{ distanceDisplay + ' km' }}</small>
            </div>
        </div>

        <div class="d-grid">
            <router-link class="btn btn-outline-primary" :to="'/mission/' + mission.id">
                Ouvrir la mission
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RightMissionPanel',
    props: {
        mission: { type: Object, required: true },
        showCorridoring: { type: Boolean, default: true }
    },
    emits: ['update:showCorridoring'],
    computed: {
        corridoringName() {
            return this.mission?.corridoring?.name || '';
        },
        distanceDisplay() {
            const dkm = this.mission?.distanceKm;
            if (dkm !== undefined && dkm !== null && !Number.isNaN(Number(dkm))) {
                return `${Number(dkm)}`;
            }
            const d = this.mission?.distance;
            if (d !== undefined && d !== null && !Number.isNaN(Number(d))) {
                return `${Number(d)}`;
            }
            return '—';
        }
    }
}
</script>

<style scoped>
.rmp {
    font-size: .95rem;
}

.small-text {
    font-size: 0.9em;
}
</style>